var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex gap-1"},_vm._l((_vm.badges),function(badge,i){return _c('ProductCardBadge',{key:i,attrs:{"badge-class":badge.badgeClass,"badge-translation-key":badge.badgeTranslationKey}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }